import * as actionTypes from '../../../actions/actionTypes';
import { updateObject } from '../../../utility';

const initialState = {
  users: null,
  count: null,
  openUserId: null,
  msg: null,
  loading: null,
  error: null,
};

const openUser = (state, action) => {
  return updateObject(state, { openUserId: action.userId });
};

const fetchUsersStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const fetchUsersSuccess = (state, action) => {
  return updateObject(state, {
    count: action.count,
    users: action.users,
    error: null,
    loading: false,
  });
};

const fetchUsersFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// for create client
const createClientStart = (state, action) => {
  return updateObject(state, { msg: null, error: null, loading: true });
};

const createClientSuccess = (state, action) => {
  return updateObject(state, {
    msg: action.msg,
    error: null,
    loading: false,
  });
};

const createClientFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    msg: null,
  });
};

// delete client
const deleteClientSuccess = (state, action) => {
  const updatedArray = state.users.filter(
    (client) => client._id !== action.clientId
  );
  // console.log(updatedArray);
  return updateObject(state, {
    users: updatedArray,
    error: null,
    loading: false,
  });
};

const ClearSuccessCreateUser = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    msg: null,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_USER_ID:
      return openUser(state, action);

    case actionTypes.FETCH_USERS_START:
      return fetchUsersStart(state, action);
    case actionTypes.FETCH_USERS_SUCCESS:
      return fetchUsersSuccess(state, action);
    case actionTypes.FETCH_USERS_FAIL:
      return fetchUsersFail(state, action);

    case actionTypes.CREATE_CLIENT_START:
      return createClientStart(state, action);
    case actionTypes.CREATE_CLIENT_SUCCESS:
      return createClientSuccess(state, action);
    case actionTypes.CREATE_CLIENT_FAIL:
      return createClientFail(state, action);

    case actionTypes.DELETE_CLIENT_SUCCESS:
      return deleteClientSuccess(state, action);

    case actionTypes.CLEAR_SUCCESS_MSG:
      return ClearSuccessCreateUser(state, action);
    default:
      return state;
  }
};

export default reducer;
